import React, {useContext} from "react";
import ApplicationContext from "./ApplicationContext";
import './menu.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars } from '@fortawesome/fontawesome-free-solid'

export default function Menu(){

    const {scrollto, toggleMenu} = useContext(ApplicationContext);

    function navigate(element){
        scrollto(element);
        toggleMenu();
    }

    return(
        <div id="menu" className="Menu_bar_full">
            <div className="Menu_bar_items">
                <div className="Menu_bar_title">
                    <img src='caricaturaMarco.png' alt='Marco Chaddoud' title='Marco Chaddoud' />
                    Marco Chaddoud
                </div>
                <div className="Menu_bar_items_buttons">
                    <ul>
                        <li className="Menu_bar_items_buttons_button" onClick={() => scrollto('app')}>Home</li>
                        <li className="Menu_bar_items_buttons_button" onClick={() => scrollto('about')}>About</li>
                        <li className="Menu_bar_items_buttons_button" onClick={() => scrollto('highlights')}>Highlights</li>
                        <li className="Menu_bar_items_buttons_button" onClick={() => scrollto('tech_summary')}>Technical Summary</li>
                        <li className="Menu_bar_items_buttons_button" onClick={() => scrollto('experience')}>Professional Experience</li>
                        <li className="Menu_bar_items_buttons_button" onClick={() => scrollto('education')}>Education</li>
                        <li className="Menu_bar_items_buttons_button" onClick={() => scrollto('contact')}>Contact</li>
                    </ul>
                </div>
            </div>

            <div id="Menu_hamburguer" className="Menu_hamburguer_menu_full">
                <div className="Menu_hamburguer_icon" onClick={() => toggleMenu()}>
                    <FontAwesomeIcon icon={faBars} color={'#FFFFFF'} />
                </div>
                <ul id="hamburguer_items" className="Menu_hamburguer_items_collapsed">
                    <li className="Menu_hamburguer_items_button" onClick={() => navigate('app')}>Home</li>
                    <li className="Menu_hamburguer_items_button" onClick={() => navigate('about')}>About</li>
                    <li className="Menu_hamburguer_items_button" onClick={() => navigate('highlights')}>Highlights</li>
                    <li className="Menu_hamburguer_items_button" onClick={() => navigate('tech_summary')}>Technical Summary</li>
                    <li className="Menu_hamburguer_items_button" onClick={() => navigate('experience')}>Professional Experience</li>
                    <li className="Menu_hamburguer_items_button" onClick={() => navigate('education')}>Education</li>
                    <li className="Menu_hamburguer_items_button" onClick={() => navigate('contact')}>Contact</li>
                </ul>
            </div>
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/Menu.js